<template>
  <div class="fixed_popup">
    <div class="row m-0 justify-content-center align-items-center h-100" @click.self="closeLogin">
      <div class="col-md-7 col-lg-6 col-sm-12 mt-3">
        <div @click="closeLogin" class="close_icon cursor">
          <ios-close-icon />
        </div>
        <form class="form_holder p-3" id="login-form" role="form" style="display: block;" @submit.prevent="onSubmit">
          <h3 class="text-center">Login</h3>
          <div class="row m-0 p-4">
            <div class="col-12 p-0">
              <div class="form-group">
                <input
                  type="email"
                  name="email"
                  id="email"
                  class="form-control"
                  placeholder="Email Address"
                  v-model="email"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  type="password"
                  name="password"
                  id="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="password"
                  required
                />
              </div>
              <div class="form-group mt-5">
                <button type="submit" class="btn btn-outline" style="width: 100%" :disabled="isLoading">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin" />
                  Log in
                </button>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="text-center smaller_font">
                      Forgot password? <a @click="forgot" class="cursor">Click here</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="text-center smaller_font">
                      Don't have an account? <a @click="register" class="cursor">Register</a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group m-0 text-center cursor">
                <a @click="register">Register</a>
              </div> -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
export default {
  data () {
    return {
      email: '',
      password: '',
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['addMessage', 'clearMessage', 'loginWithEmail']),
    onSubmit () {
      this.isLoading = true
      let data = {
        email: this.email,
        password: this.password
      }
      this.loginWithEmail(data).then(() => {
        this.$analytics.logEvent('login', 'Email')
        this.clearMessage()
        this.closeLogin()
      }).catch((error) => {
        let messageObj = {
          message: error.message,
          messageClass: 'danger',
          autoClose: true
        }
        this.addMessage(messageObj)
      }).then(() => {
        this.isLoading = false
      })
    },
    register () {
      this.$emit('goToRegister')
    },
    forgot () {
      this.$emit('goToForgot')
    },
    closeLogin () {
      this.$emit('closeLogin')
    }
  }
}
</script>
<style scoped>
.fixed_popup {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--dark-color-08);
}
.close_icon {
  position: absolute;
  right: 15px;
  top: 0;
  text-align: right;
  color: var(--dark-color);
}
.dark-mode .close_icon {
  color: var(--light-color);
}
.smaller_font {
  font-size: small;
}
</style>
